import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  OportunidadSection,
  AboutSection,
  Alcance,
  ContenidoParaMarcas,
  InversionSection,
  PorQueTNO,
  AreYouReady,
} from './components';

const LandingMediaKitOpticaBerlud = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
        position="relative"
      >
        <Hero themeMode={themeMode} />
      </Box>
      <Container>
        <OportunidadSection />
      </Container>
      <Container>
        <AboutSection />
      </Container>
      <Container>
        <Alcance />
      </Container>
      <Container>
        <ContenidoParaMarcas />
      </Container>
      <Container>
        <InversionSection />
      </Container>
      <Box bgcolor={theme.palette.alternate.main}>
        <Container>
          <PorQueTNO />
        </Container>
      </Box>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitOpticaBerlud.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitOpticaBerlud;
